import React from 'react';

export default function EditIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.73512 2.09996L2.94595 7.16913C2.76512 7.36163 2.59012 7.7408 2.55512 8.0033L2.33928 9.8933C2.26345 10.5758 2.75345 11.0425 3.43012 10.9258L5.30845 10.605C5.57095 10.5583 5.93845 10.3658 6.11928 10.1675L10.9085 5.0983C11.7368 4.2233 12.1101 3.2258 10.8209 2.00663C9.53762 0.79913 8.56345 1.22496 7.73512 2.09996Z"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M6.93579 2.9458C7.18662 4.5558 8.49329 5.78663 10.115 5.94997"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M1.75 12.8333H12.25"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
